<template>
  <div>
   <reports />
  </div>
</template>

<script>
import reports from '../../../../components/tax/delinquent/commissionersSale/Reports.vue';

export default {
  name: 'CommissionersSaleReports',
  components: {
    reports,
  },
};
</script>
